import { Input, Label } from '@fluentui/react-components';
import styled from 'styled-components';

export const TicketInfoLabel = styled(Label)`
  font-weight: 500;
`;

export const InputWithLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: default;
`;

export const StyledInput = styled(Input)`
  border: 1px solid ${(props) => props.theme.popupInputBorderColor};
  border-radius: 4px;
  padding: 0px 10px 0px 10px;

  &:hover {
    border: 1px solid ${(props) => props.theme.popupInputBorderColor};
    border-radius: 4px;
  }
`;
